import { EquipmentOptions, EquipmentType, IEquipmentOption } from '@oneethos/shared'
import React, { useEffect, useState } from 'react'


interface EquipmentsProps {
  onChange: (selectedEquipment: IEquipmentOption) => void
  isOrgTeslaCertified: boolean
  isResidential: boolean
}

export const Equipments = ({ onChange, isOrgTeslaCertified, isResidential }: EquipmentsProps) => {

  const [selectedCard, setSelectedCard] = useState<string>(null)

  useEffect(() => {
    const initialCard = isOrgTeslaCertified && isResidential 
    ? EquipmentType.TeslaRoof 
    : EquipmentType.StandardSolar

    setSelectedCard(initialCard)
  },[ isOrgTeslaCertified, isResidential ])

  const availableEquipments = EquipmentOptions.filter(card => {
    if (card.id === EquipmentType.StorageOnly) {
      return isResidential
    }
    
    if (isOrgTeslaCertified) {
      return isResidential ? card : !card.isTesla
    } else {
      return !card.isTesla
    }
  })

  const handleCardSelect = (card: IEquipmentOption) => {
    setSelectedCard(card.id)
    onChange(card)
  }

  return (
    <div className='equipment-selector d-flex gap-3 mb-3 flex-column flex-md-row align-items-center align-items-md-stretch'>
      {availableEquipments.map((card) => (
        <div
          key={card.id}
          className={`card pointer equipment-card ${selectedCard === card.id ? 'border-primary border-2' : ''}`}
          onClick={() => handleCardSelect(card)}
        >
          <img
            src={card.image}
            className="card-img-top"
            alt={card.title}
          />
          <div className="card-body">
            <h5 className="card-title">{card.title}</h5>
            <p className="card-text">{card.description}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Equipments
